import $ from 'jquery';
import {is_function} from '../../../Helpers/js/simple.functions';
import LP from '../0-lp';

//----------------------- //
// Text-Editor Dialog     //
//----------------------- //

LP.Dialog.TextEditor = {
  editorParams: {},

  onLoad: function () {
    $('#editorLoader').timedLoader(1).show();

    var params = LP.Dialog.getParams();

    LP.Dialog.TextEditor.editorParams.element = params.element;
    LP.Dialog.TextEditor.editorParams.useContent = params.useContent;
    LP.Dialog.TextEditor.editorParams.usePollStyle = $('#usePollStyle').length == 1;
    LP.Dialog.TextEditor.editorParams.afterSubmit = params.afterEditorSubmit;
    LP.Dialog.TextEditor.editorParams.beforeSubmit = params.beforeEditorSubmit;

    const froalaDiv = document.getElementById('froala');
    window.reactPortals.addPollTextEditor(froalaDiv);
  },

  onOpen: function () {
    $('#editorLoader').timedLoader(false).hide().addClass('hide');

    LP.Dialog.onOpen();
  },

  onClose: function () {
    $('#editorLoader').timedLoader(1).show();

    return false;
  },

  trimContent: function (content) {
    if (content && content.endsWith('<br>')) {
      content = content.substring(0, content.length - 4);
    }
    return $.trim(content);
  },

  afterSubmit: function (json) {
    if (is_function(LP.Dialog.TextEditor.editorParams.afterSubmit)) {
      LP.Dialog.TextEditor.editorParams.afterSubmit(json);
    }
  },

  beforeSubmit: function () {
    var content = $('#froala').find('.fr-view').html();
    content = LP.Dialog.TextEditor.trimContent(content);

    if (LP.Dialog.TextEditor.editorParams.element) {
      if (LP.Dialog.TextEditor.editorParams.useContent) {
        LP.Dialog.TextEditor.editorParams.element.html(content);
      } else {
        LP.Dialog.TextEditor.editorParams.element.val(content);
      }
    }

    if (is_function(LP.Dialog.TextEditor.editorParams.beforeSubmit)) {
      LP.Dialog.TextEditor.editorParams.beforeSubmit(content);
    }

    return true;
  },
};
